function previewLine(room) {
  const latest = room?.latestMessage
  if (!latest) return 'No messages yet'
  const text = (latest.text || '').trim() || 'Attachment'
  return `${latest.authorName || 'Member'}: ${text}`
}

function isUnread(room, userId) {
  const latest = room?.latestMessage
  if (!latest || room.muted || !userId) return false
  return !(latest.views || []).some((id) => String(id) === String(userId))
}

function ChatList({ rooms, status, selectedId, userId, onSelect, empty }) {
  if (status === 'loading' && !rooms.length) return <div className="crm-status">Loading…</div>
  if (status === 'error') return <div className="crm-status">Could not load chats.</div>
  if (!rooms.length) return <div className="crm-status">{empty || 'No chats yet.'}</div>

  const open = rooms.filter((room) => !room.muted)
  const muted = rooms.filter((room) => room.muted)

  const row = (room) => {
    const selected = String(room._id) === String(selectedId)
    const unread = isUnread(room, userId)
    return (
      <button
        key={room._id}
        type="button"
        className={'crm-row' + (selected ? ' is-selected' : '') + (unread ? ' is-unread' : '')}
        onClick={() => onSelect(room)}
      >
        <span className="crm-row-name">{room.displayLabel || 'Chat'}</span>
        <span className="crm-row-meta">{previewLine(room)}</span>
      </button>
    )
  }

  return (
    <div className="crm-list">
      {open.map(row)}
      {muted.length ? (
        <>
          <div className="crm-section">Muted</div>
          {muted.map(row)}
        </>
      ) : null}
    </div>
  )
}

export default ChatList
